/* Animations discrètes de l'accueil */
(function () {
  'use strict';
  var els = document.querySelectorAll('[data-fx="reveal"]');
  var cars = document.querySelectorAll('.m3-car');

  cars.forEach(function (car) {
    car.querySelectorAll('.m3-car__item').forEach(function (it, i) { it.style.setProperty('--i', Math.min(i, 6)); });
  });

  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('is-in'); });
    cars.forEach(function (c) { c.classList.add('fx-in'); });
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      en.target.classList.add('is-in');
      io.unobserve(en.target);
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.06 });
  els.forEach(function (el) { io.observe(el); });

  var io2 = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      en.target.classList.add('fx-in');
      io2.unobserve(en.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
  cars.forEach(function (c) { io2.observe(c); });
})();
